import { useState, useEffect } from "react";
import { getPresences, onPresenceChange, type PresenceUser } from "../collab/presence";

const MAX_VISIBLE = 5;

interface PresenceAvatarsProps {
  followClientId?: number | null;
  onFollowToggle?: (clientId: number) => void;
}

export default function PresenceAvatars({ followClientId, onFollowToggle }: PresenceAvatarsProps = {}) {
  const [users, setUsers] = useState<PresenceUser[]>([]);

  useEffect(() => {
    const refresh = () => setUsers(getPresences());
    refresh();
    return onPresenceChange(refresh);
  }, []);

  if (users.length === 0) return null;

  const visible = users.slice(0, MAX_VISIBLE);
  const overflow = users.length - MAX_VISIBLE;

  return (
    <div className="presence-avatars">
      {visible.map((u) => (
        <div
          key={u.clientId}
          className={`presence-avatar ${followClientId === u.clientId ? "presence-avatar--following" : ""}`}
          style={{ background: u.color }}
          title={followClientId === u.clientId ? `Following ${u.name} (click to stop)` : `${u.name} (click to follow)`}
          onClick={() => onFollowToggle?.(u.clientId)}
        >
          {u.name.charAt(0).toUpperCase()}
          {followClientId === u.clientId && (
            <svg className="presence-follow-icon" viewBox="0 0 16 16" fill="currentColor" width="8" height="8">
              <path d="M8 3l1.5 3 3.5.5-2.5 2.5.5 3.5L8 11l-3 1.5.5-3.5L3 6.5 6.5 6z"/>
            </svg>
          )}
        </div>
      ))}
      {overflow > 0 && (
        <div className="presence-overflow">+{overflow}</div>
      )}
    </div>
  );
}
